import * as React from 'react';
import { storyblokEditable } from 'gatsby-source-storyblok';
import Container from '../Container';
import FancyTitle from '../fancy-title';
import { renderReferenceRichText } from './reference-section-helpers';
import { getStoryblokAlt } from '../../helpers/common';

function getStoryblokDimensions(filename) {
  const [width, height] = filename?.split('/')[5]?.split('x') || [];
  return {
    width: Number(width) || undefined,
    height: Number(height) || undefined,
  };
}

function getStoryblokImageUrl(filename, width = 120, format = 'webp') {
  if (
    !filename
    || filename.includes('.svg')
    || !filename.includes('a.storyblok.com')
  ) {
    return filename;
  }

  return `${filename}/m/${width}x${width}/filters:format(${format})`;
}

export function QuotationCard({ blok, className = '' }) {
  const quoteClass = 'max-w-3xl mx-auto text-center text-[16px] leading-[24px]';
  const personLine = blok?.person_line || [blok?.name, blok?.role].filter(Boolean).join(', ');
  const image = blok?.avatar;
  const imageFilename = image?.filename;
  const { width, height } = getStoryblokDimensions(imageFilename);

  return (
    <div className={`border-2 border-latori-green-dark rounded-md px-6 py-10 lg:px-10 lg:py-12 ${className}`}>
      <div className="flex flex-col items-center text-center">
        {imageFilename && (
          <img
            src={getStoryblokImageUrl(imageFilename, 120)}
            alt={getStoryblokAlt(image, personLine || '')}
            width={width || 80}
            height={height || 80}
            className="w-16 h-16 lg:w-20 lg:h-20 rounded-full object-cover"
            loading="lazy"
            decoding="async"
          />
        )}

        {personLine && (
          <FancyTitle
            text={personLine}
            subtitle=""
            tag="p"
            textAlign="text-center"
            marginBottom="mb-8"
            className="mt-4"
          />
        )}

        {blok?.quote
          && (typeof blok.quote === 'string' ? (
            <p className={`${quoteClass}`}>{blok.quote}</p>
          ) : (
            renderReferenceRichText(blok.quote, quoteClass)
          ))}
      </div>
    </div>
  );
}

export function QuotationSlide({ blok, fillHeight = false, titleHeight = 0 }) {
  const titleAlign = blok?.title_align === 'center' ? 'text-center' : 'text-left';
  const titleNode = blok?.title && (
    <FancyTitle
      text={blok.title}
      tag={blok.title_tag || 'h2'}
      textAlign={titleAlign}
      marginBottom={fillHeight ? 'mb-0' : 'mb-8'}
    />
  );

  return (
    <div {...storyblokEditable(blok)} className={fillHeight ? 'flex flex-col h-full' : ''}>
      {fillHeight ? (
        (blok?.title || titleHeight > 0) && (
          <div className="mb-8 flex flex-col justify-end" style={{ minHeight: titleHeight }}>
            <div data-quotation-title>{titleNode}</div>
          </div>
        )
      ) : titleNode}
      <QuotationCard blok={blok} className={fillHeight ? 'flex-1' : ''} />
    </div>
  );
}

export default function QuotationBox({ blok }) {
  return (
    <section className="py-12 lg:py-20">
      <Container>
        <QuotationSlide blok={blok} />
      </Container>
    </section>
  );
}
